import fetcher from 'modules/fetcher'
import { EMAIL_VALIDATION_API_URL } from './constants'
import { notify } from 'utils/notify'
// eslint-disable-next-line no-restricted-imports -- non-React module
import { t } from 'i18n/utils'

export const verifyEmail = async (
  email,
  successCallback,
  errorCallback = handleEmailVerificationError
) => {
  return callEmailVerificationEndpoint(email).then(res => {
    successCallback && successCallback(res)
  }).catch(error => {
    errorCallback && errorCallback(error)
  })
}

export const callEmailVerificationEndpoint = async (email) => {
  return fetcher(EMAIL_VALIDATION_API_URL + email, {
    method: 'GET'
  })
}

export const handleEmailVerificationError = (error) => {
  switch (error.response.status) {
    case 502:
      notify(t('emailValidation.errors.serviceError'), { type: 'error' })
      break
    case 504:
      notify(t('emailValidation.errors.serviceUnavailable'), { type: 'error' })
      break
    case 401:
      notify(t('emailValidation.errors.quotaExceeded'), { type: 'warning' })
      break
    default:
      notify(t('emailValidation.errors.unexpectedError'), { type: 'error' })
  }
}
